import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { episodeOfCareAction } from '../../actions/constant';
import episodeOfCare from '../../../services/apiServices/episodeOfCare/episodeOfCare';
const {
  CLOSE_EPISODE_OF_CARE_FAILURE,
  CLOSE_EPISODE_OF_CARE_SUCCESS,
  ClOSE_EPISODE_OF_CARE_REQUEST,
  CLOSE_EPISODE_OF_CARE_LOADING,
} = episodeOfCareAction;

function* closeEpisodeOfCare(payload: any): SagaReturnType<any> {
  try {
    yield put({ type: CLOSE_EPISODE_OF_CARE_LOADING });
    const response = yield call(episodeOfCare.closeEpisodeOfCare, payload?.payload);
    if (response?.status === 200) {
      yield put({ type: CLOSE_EPISODE_OF_CARE_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: CLOSE_EPISODE_OF_CARE_FAILURE, payload: error });
  }
}

function* closeEpisodeOfCareSaga() {
  yield takeEvery(ClOSE_EPISODE_OF_CARE_REQUEST, closeEpisodeOfCare);
}

export default closeEpisodeOfCareSaga;
